import { colorSystem } from '../../../theme';
import { Flexbox, FlexboxProps } from '../../Flexbox';

export const StickyLayout = (props: FlexboxProps): JSX.Element => (
    <Flexbox
        gap={8}
        style={{
            background: colorSystem.neutral.white,
            ...props.style,
        }}
        {...props}
        sx={[
            {
                position: 'sticky',
                top: '0',
                left: '0',
                zIndex: '10',
                flexDirection: 'column',
                maxWidth: '100%',
            },
            ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
        ]}
    />
);
